const reviews = [
  {
    id: 1,
    name: "Alecsandra A.",
    text: "My daughter wanted a side shaved. Found Kelly on Facebook. She did an amazing job with my daughters hair. She was most kind, extra patient with my 8 year old, knowledgeable and affordable. We will be back!",
  },
  {
    id: 2,
    name: "Jane Smith",
    text: " I did it! I finally got unicorn hair! well at least I feel like a unicorn and it was such a wonderful experience! I can't gush enough about how fabulous this lady is and about how much I love my hair! Don't question it, you find the best place, just go to Kelly! You can't help but leave feeling fabulous and uncontrollably wanting to show off your new do! All the exclamation marks are necessary.",
  },
  {
    id: 3,
    name: "Kate F.",
    text: "Kelly took my idea of an outside of the box haircut and came through in a huge way! I had such a great experience. I'll be going back for sure. My cut is exactly what I hoped for. Plus Kelly is good people!",
  },
  {
    id: 4,
    name: "Elizabeth M",
    text: "Amazing with kids! My son had his hair cut with her and she is awesome!!",
  },
  {
    id: 5,
    name: "Sarah Wilson",
    text: "I've been going to Kelly for a little over a year now, and as long as she's still barbering I'll always go to her. She took me from super long unmanageable hair to a fun pretty lady barber look! She colors my hair too and I’m always walking out of there confident and fresh! Best barber ever",
  },
  {
    id: 6,
    name: "Bonnie K.",
    text: "Kelly is the best there is. Only one that touches my hair.",
  },
  {
    id: 7,
    name: "Tootsie",
    text: "My daughter and I love The Style Emporium! It's always a great experience from start to finish. The atmosphere is modern and welcoming and the staff is incredibly professional and friendly. Kelly has been helping me achieve my color dreams and is highly skilled, paying great attention to detail and listening closely to my preferences. I left with a flawless cut and color that exceeded my expectations, and I could tell that she truly cares about her craft. I highly recommend this place for anyone looking for high-quality service and a fantastic stylist or barber. I'll definitely be returning!",
  },
  {
    id: 8,
    name: "Megan",
    text: 'Today we saw Kelly & Angela at The Style Emporium and it was such a fabulous experience! They were so kind and great with our kiddos. The environment is awesome, and the kids were able to play Foosball while waiting for their cuts. They are currently offering "Hope Haircuts" for foster families on the first Friday & Saturday of each month for $15. What a huge blessing!! Thank you, Kelly & Angela for having such huge hearts. We loved our cuts and your have our future business!',
  },
  {
    id: 9,
    name: "Rebbeca",
    text: "If you not only want the best grooming/ beauty care you can get in Colorado Springs, if you're lucky you could end up meeting some great friends as well! The atmosphere is sooooo welcoming (and the sweetest dog ever) is usually there! Please run, don't walk to this amazing place! You will not be disappointed!",
  },
];

export default reviews;
